import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Drawer,
  Empty,
  Form,
  Row,
  Space,
} from "antd";
import PageSpinner from "../../../../components/PageSpinner/PageSpinner";
import {
  exportFormFields,
  exportList,
} from "../../../../store/CompanyManagementSlice";
import { AppDispatch } from "../../../../store/app";
import { camelCaseString, downloadCSV } from "../../../../config/Global";

interface props {
  visible: boolean;
  close: any;
  savePayload: any;
}

const ExportForm: React.FC<any> = (props: props) => {
  const { visible, close, savePayload } = props;
  const CheckboxGroup = Checkbox.Group;
  const dispatch: AppDispatch = useDispatch();
  const [formFields, setFormFields] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [checkedList, setCheckedList] = useState<string[]>([]);

  useEffect(() => {
    dispatch(exportFormFields())
      .then((res: any) => {
        setFormFields(res?.data?.data);
      })
      .catch((e: any) => {
        console.warn(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [dispatch]);

  const closeDrawer = () => {
    close();
    setFormFields([]);
    setCheckedList([]);
  };

  const onCheckAllChange = (e: any) => {
    setCheckedList(e.target.checked ? formFields : []);
  };

  const onChange = (list: string[]) => {
    setCheckedList(list);
  };

  const checkAll = formFields.length === checkedList.length;
  const indeterminate =
    checkedList.length > 0 && checkedList.length < formFields.length;

  const handleSubmit = () => {
    const payload = {
      selectedFields: checkedList,
      company_name: savePayload?.company_name,
      company_id: savePayload?.company_id,
    };
    dispatch(exportList(payload))
      .then((res: any) => {
        downloadCSV(res, "CompanyManagement.csv");
      })
      .catch((e: any) => {
        console.warn(e);
      });
  };

  return (
    <>
      {!loading ? (
        <Drawer
          open={visible}
          onClose={closeDrawer}
          destroyOnClose
          width={800}
          title="Export CSV"
          footer={[
            <Space direction="horizontal" size="middle">
              <Button
                type="primary"
                htmlType="submit"
                form="exportCsv"
                disabled={checkedList.length <= 0 ? true : false}
              >
                Export
              </Button>
              <Button onClick={closeDrawer}>Cancel</Button>
            </Space>,
          ]}
        >
          {formFields?.length ? (
            <Form onFinish={handleSubmit} id="exportCsv">
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <Checkbox
                    indeterminate={indeterminate}
                    onChange={onCheckAllChange}
                    checked={checkAll}
                  >
                    Check all
                  </Checkbox>
                </Col>
                <Divider className="m-0" />
                <Col span={24}>
                  <CheckboxGroup value={checkedList} onChange={onChange}>
                    <Row gutter={[16, 16]}>
                      {formFields.map((field: string) => (
                        <Col key={field} span={6}>
                          <Checkbox value={field}>
                            {camelCaseString(field)}
                          </Checkbox>
                        </Col>
                      ))}
                    </Row>
                  </CheckboxGroup>
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  {checkedList.length <= 0 && (
                    <p className="ant-form-item-explain-error mt-20">
                      {" "}
                      Please select at least one field.
                    </p>
                  )}
                </Col>
              </Row>
            </Form>
          ) : (
            <Empty />
          )}
        </Drawer>
      ) : (
        <PageSpinner />
      )}
    </>
  );
};

export default ExportForm;
